// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"48ed94f5","787":"09c4dc52","975":"77911fb0"}[chunkId] + ".chunk.js";
};